import { wait } from "./wait";

/**
 * Run `callback` until it returns false, or until `timeout` milliseconds have
 * passed. Bubbles up any errors thrown by `callback`.
 *
 * Very useful utility for doing intensive things in a loop where you need to
 * do some work, pause, do some work, etc. for a specific amount of time. Allows
 * you to put an upper boundary on timing for things like long-running, DB-
 * intensive ops like deletions.
 */
export async function loopUntilFalse({
  callback,
  timeoutMs = 1000 * 60 * 60 * 24, // 24 hours is reasonable default timeout
  pauseMsBetweenLoops = 0,
}: {
  callback: () => boolean | Promise<boolean>;
  pauseMsBetweenLoops?: number;
  timeoutMs?: number;
}): Promise<void> {
  const startTime = Date.now();
  while (Date.now() - startTime < timeoutMs) {
    if (!(await callback())) {
      return;
    }
    await wait(pauseMsBetweenLoops);
  }
}
